// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__h7nF0","content":"Layout_content__vOrgZ"};